(() => {
  const publish = (eventName, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    window.Shopify?.analytics?.publish?.(`the_limely:${eventName}`, payload);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const supportLink = event.target.closest('[data-pdp-support-link]');
    if (!supportLink) return;

    const support = supportLink.closest('[data-pdp-support]');
    publish('pdp_support_click', {
      page_path: window.location.pathname,
      product_handle: support?.dataset.productHandle || '',
      product_id: support?.dataset.productId || '',
      support_type: supportLink.dataset.pdpSupportLink || '',
      destination_host: new URL(supportLink.href, window.location.href).host
    });
  });
})();
